import React, { useContext, useMemo } from 'react';
import DatasetDefinitionsContext from 'contexts/DatasetDefinitionsContext';

const useBonusProgramOptions = ({
  selectedBonusProgram,
  setSelectedBonusProgram,
  setTitle,
}: {
  selectedBonusProgram: BonusTypes.BonusProgram | undefined;
  setSelectedBonusProgram: React.Dispatch<
    React.SetStateAction<BonusTypes.BonusProgram | undefined>
  >;
  setTitle: React.Dispatch<React.SetStateAction<string>>;
}) => {
  const { bonusPrograms } = useContext(DatasetDefinitionsContext);

  const options = useMemo(() => {
    return bonusPrograms.map((d) => ({
      key: d.id,
      label: d.name,
      isSelected: !!selectedBonusProgram && d.id === selectedBonusProgram.id,
      onSelected: () => {
        setSelectedBonusProgram(d);
        setTitle(d.name);
      },
    }));
  }, [bonusPrograms, selectedBonusProgram, setSelectedBonusProgram, setTitle]);

  return options;
};

export default useBonusProgramOptions;
